// extracted by mini-css-extract-plugin
export default {"label":"label--EJL1P","disabled":"disabled--vr10p","wrapper":"wrapper--SjwGo","small":"small--onoqt","xsmall":"xsmall--hkTNR","input":"input--h83XI","switch":"switch--I4Zsx"};